/**
 * Check if the value is NOT null or undefined.
 *
 * DO NOT negate this function, use `isNullish` instead.
 * ```ts
 * ❌ !isNonNullish(value)
 * ✅ isNullish(value)
 * ```
 *
 * This becomes especially useful for filtering out
 * null or undefined values from an array.
 *
 * @example
 * ```ts
 * declare const arr: (string | undefined)[]
 * const arr2 = arr.filter(isNonNullish)
 *    // ^? arr2: string[]
 * ```
 */
export function isNonNullish<T>(value: T): value is NonNullable<T> {
  return value !== undefined && value !== null
}
